module.exports = __webpack_public_path__ + "static/media/whychoose_1.e36bb9dc.jpg";